import { useMutation, useQueryClient } from "@tanstack/vue-query";
import ProjectsApi from "@/common/http/ProjectsApi";
import { onSettled } from "./onSettled";

export const mutationKey = ["delete-recommendation-feedback"];

export const useDeleteRecommendationFeedback = (props = {}) => {
  const queryClient = useQueryClient();

  const { mutate, ...mutationRest } = useMutation({
    mutationFn: ProjectsApi.deleteRecommendationFeedback,
    mutationKey,
    onSettled: onSettled({ queryClient }),
    ...props,
  });

  return {
    deleteRecommendationFeedback: mutate,
    ...mutationRest,
  };
}
